import type { CountryCode } from '@/helpers/country-codes'
import { includes } from '@/helpers'

export const supportedFlags: CountryCode[] = ['CA', 'ZA']

export type SupportedFlag = (typeof supportedFlags)[number]

export function isSupportedFlag(
    countryCode: CountryCode
): countryCode is SupportedFlag {
    return includes(supportedFlags, countryCode)
}
